import { Component, OnInit} from "@angular/core";

@Component({
  selector: 'openpay-header-component',
  templateUrl: './openpay-header.component.html',
  styleUrls: ['./openpay-header.component.scss']
})

export class OpenpayHeaderComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
